"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupStyle = void 0;
exports.PopupStyle = {
    background: 'white',
    borderColor: "var(--context-menu-border-color, #C9C9C9)",
    borderRadius: "var(--context-menu-border-radius, 1px)",
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: 'var(--context-menu-box-shadow, 0px 2px 16px 0px rgba(46, 46, 46, 0.15))',
    boxSizing: 'border-box',
    lineHeight: 'normal',
};
//# sourceMappingURL=Standard.js.map